import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Table } from 'reactstrap';
import Skeleton from 'react-loading-skeleton';
import Actions from '../../../Actions';
import Paginate from '../Layout/Paginate';
import TypeRow from './TypeRow';
import Edit from './Edit';
import Add from './Add';
import Tile from '../Layout/Tile';
import Filter from '../Layout/Filter';


class TypeList extends Component {
    componentDidMount = () => {
        const { auth, getTypes } = this.props;
        getTypes(auth.token, {page: 1, order: "asc", sort: "name" }, false);
    }

    edit = (id) => {
        const { types, toggleModal, setModalData } = this.props;
        if(types.hasOwnProperty(id)){
            setModalData("types","edit",types[id]);
            toggleModal("types","edit");
        }
    }

    typesLoading = () => {
        const data = [];
        for(let i=0;i<10;i++){
            data.push(
                <Tile key={i+"-loading"} xs="12" style={{padding: "1vh 1vw"}} className="mx-auto">
                    <Skeleton count={4}/>
                </Tile>
            );
        }

        return data;
    }

    types = () => {
        const { types, typesMeta } = this.props;
        const rows = [];
        const { data = [] } = typesMeta;
        data.map((id) => {
            rows.push(
                <TypeRow key={id} edit={this.edit} type={types[id]}/>
            );
        });
        return rows;
    }

    render(){
        const { getTypes, typesLoading, typesMeta, query } = this.props;
        return (
            <div style={{ padding: "3px"}}>        
               { typesLoading ? this.typesLoading():
                <Row>
                    <Col lg="5" md="6" xs="12">
                        <Table responsive className="text-left">
                                <thead>
                                    <tr>
                                        <th className="text-nowrap">
                                            <Filter query={query} id="name" title="Job Type" field="name" filter={getTypes} />
                                        </th>
                                        <th>
                                            Delete
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.types()}
                                </tbody>
                        </Table>
                        <Paginate fetch={getTypes} meta={typesMeta}  />
                        <Edit />
                        <Add />
                    </Col>
                </Row>
               }
            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    auth: state.auth,
    types: state.typeStore.types,
    typesMeta: state.typeStore.typesMeta,
    query: state.typeStore.query,
    typesLoading: state.typeStore.typesLoading,
});

const { types, modals } = Actions;

export default connect(mapStateToProps, { ...types, ...modals })(TypeList);


// WEBPACK FOOTER //
// ./src/Components/App/Types/TypeList.js